import React, { useState, useEffect } from 'react';
import IGroupDetail from '@Shared.Angular/@types/core/contracts/queryModel/group/groupDetail';
import { Guid } from '@Shared.Angular/@types/guid';
import { getService } from '@Shared.Angular/flowingly.hooks/useService';
import { KendoReactComboBox } from '@Shared.Angular/kendo.react/KendoReactComboBox';
import { ComboBoxChangeEvent, ComboBoxFilterChangeEvent } from '@progress/kendo-react-dropdowns';

type Props = {
  selectedTeamId?: Guid;
  disabled?: boolean;
  onTeamSelect?: (team: IGroupDetail | null) => void;
  popupClassName?: string;
  inputId?: string;
  placeholder?: string;
};

const SelectTeam = (props: Props) => {
  const {
    selectedTeamId,
    disabled,
    onTeamSelect,
    inputId,
    placeholder = 'Select Team'
  } = props;

  const [teams, setTeams] = useState<IGroupDetail[]>([]);
  const [filteredTeams, setFilteredTeams] = useState<IGroupDetail[]>([]);
  const [selectedTeam, setSelectedTeam] = useState<IGroupDetail | null>(null);

  const teamApiService = getService('teamApiService');

  const fetchTeams = async () => {
    try {
      const teamsResult = await teamApiService.getTeamsWithOptions({});
      const allTeams = teamsResult.teams || [];
      setTeams(allTeams);
      setFilteredTeams(allTeams);
    } catch (err) {
      setTeams([]);
      setFilteredTeams([]);
    }
  };

  useEffect(() => {
    fetchTeams();
  }, []);

  useEffect(() => {
    if (!selectedTeamId || teams.length === 0) {
      setSelectedTeam(null);
      return;
    }
    
    const team = teams.find((t) => t.id === selectedTeamId);
    setSelectedTeam(team || null);
  }, [selectedTeamId, teams]);

  const handleFilterChange = (event: ComboBoxFilterChangeEvent) => {
    const filterValue = event.filter.value.toLowerCase();
    
    if (!filterValue) {
      setFilteredTeams(teams);
    } else {
      const filtered = teams.filter((team) =>
        team.name.toLowerCase().includes(filterValue)
      );
      setFilteredTeams(filtered);
    }
  };

  const handleSelectionChange = (event: ComboBoxChangeEvent) => {
    const team = event.value as IGroupDetail | null;
    setSelectedTeam(team);
    onTeamSelect?.(team);
  };

  return (
    <KendoReactComboBox
      data={filteredTeams}
      textField="name"
      dataItemKey="id"
      placeholder={placeholder}
      value={selectedTeam}
      disabled={disabled}
      inputId={inputId}
      popupClassName={props.popupClassName}
      onFilterChange={handleFilterChange}
      onChange={handleSelectionChange}
    />
  );
};

export default SelectTeam;
